import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  font-family: "Roboto", sans-serif;
  background: #121212;
  color: #fff;
  min-height: 100vh;
  padding: 50px 20px;
`;

const ContentWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  background: #1e1e2f;
  padding: 40px;
  border-radius: 20px;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #00d4ff;
`;

const Section = styled.div`
  margin-bottom: 25px;
`;

const SectionTitle = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 10px;
  color: #00bcd4;
`;

const Text = styled.p`
  line-height: 1.7;
  font-size: 1rem;
  margin-bottom: 12px;
`;

const PrivacyPolicy = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <Title>Privacy Policy</Title>

        <Section>
          <SectionTitle>Introduction</SectionTitle>
          <Text>
            This Privacy Policy describes how GAURAV and its affiliates
            (collectively "GAURAV, we, our, us") collect, use, share, protect or
            otherwise process your information/personal data through our website{" "}
            <strong>https://www.engineercodewala.in/</strong> (hereinafter
            referred to as "Platform"). Please note that you may be able to
            browse certain sections of the Platform without registering with us.
          </Text>
          <Text>
            We do not offer any product/service under this Platform outside
            India and your personal data will primarily be stored and processed
            in India. By visiting this Platform, providing your information or
            availing any product/service offered on the Platform, you expressly
            agree to be bound by the terms and conditions of this Privacy
            Policy, the Terms of Use and the applicable service/product terms
            and conditions, and agree to be governed by the laws of India
            including but not limited to the laws applicable to data protection
            and privacy. If you do not agree please do not use or access our
            Platform.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Collection of Information</SectionTitle>
          <Text>
            We collect your personal data when you use our Platform, services or
            otherwise interact with us during the course of our relationship.
            Information may include name, date of birth, address, phone number,
            email ID, identity proofs, and sensitive information such as bank
            details or biometric data (with consent).
          </Text>
          <Text>
            We may also track your behaviour, preferences, and transaction data.
            Data collected by third-party partners (such as payment gateways or
            logistics providers) is governed by their respective privacy
            policies.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Usage of Information</SectionTitle>
          <Text>
            We use your personal data to provide services, process transactions,
            enhance user experience, troubleshoot issues, resolve disputes, and
            enforce our Terms. We may also use it for marketing, research,
            fraud-prevention, and improving our offerings.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Sharing of Information</SectionTitle>
          <Text>
            We may share your personal data with group entities, affiliates,
            sellers, business partners, logistics providers, payment
            intermediaries (such as PhonePe), and government authorities when
            legally required.
          </Text>
          <Text>
            We never sell your personal data. Disclosures may be required to
            comply with law, enforce agreements, protect rights, or prevent
            fraud.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Security Precautions</SectionTitle>
          <Text>
            We adopt reasonable security practices and use secure servers to
            protect your personal data. However, data transmission over the
            internet is not completely secure. You are responsible for
            protecting your account credentials.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Data Deletion & Retention</SectionTitle>
          <Text>
            You can delete your account anytime from your profile settings or by
            contacting us. Some information may be retained temporarily if
            required for pending services, disputes, or fraud prevention.
            Retained data may be anonymised for analytics and research.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Your Rights</SectionTitle>
          <Text>
            You may access, rectify, or update your personal data directly via
            the Platform. You may also opt out of promotional communications or
            withdraw consent by contacting our support team.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Consent</SectionTitle>
          <Text>
            By using the Platform, you consent to our collection, use, storage,
            and processing of your personal data in accordance with this Privacy
            Policy. Withdrawal of consent may limit our ability to provide some
            services.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Changes to this Privacy Policy</SectionTitle>
          <Text>
            We may update this Privacy Policy from time to time. Significant
            changes will be communicated as required under applicable law. We
            encourage you to periodically review this page for updates.
          </Text>
        </Section>
      </ContentWrapper>
    </PageContainer>
  );
};

export default PrivacyPolicy;
